import type { AnalyticsReportPayload } from '@/domains/stats/types/requests/AnalyticsRequest.types'
import type { AnalyticsReportResponse } from '@/domains/stats/types/responses/AnalyticsResponse.types'
import type { QueryParams } from '@/utils/url-util/urlUtil'

import { twineServiceClient } from '@/services/api'
import { relativeZiggyRoute } from '@/utils/url-util/urlUtil'

const callAnalytics = () => {
  /**
   * The dynamic-report transport. `T` is the response the caller reads: `useReportQuery` carries its own report shape.
   * GET /admin/analytics/reports/dynamic
   */
  const dynamicReport = <T = AnalyticsReportResponse>(payload: AnalyticsReportPayload = {}) => {
    return twineServiceClient.get<T, AnalyticsReportPayload>({
      endpoint: relativeZiggyRoute('admin.analytics.reports.dynamic'),
      queryParams: { ...payload.queryParams } as QueryParams<AnalyticsReportPayload>,
      preventConcurrent: payload.preventConcurrent ?? true,
      token: payload.token
    })
  }

  return { dynamicReport }
}

export { callAnalytics }
